










import { OComponentDemo } from '../../app/demo';
import OElement from './o-element.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'OElementDemo',
  components: { OElement, OComponentDemo },
});
